var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance / Credit Card 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 11.25V16.0502C3 17.1703 3 17.7301 3.21799 18.1579C3.40973 18.5342 3.71547 18.8405 4.0918 19.0322C4.5192 19.25 5.07899 19.25 6.19691 19.25H17.8031C18.921 19.25 19.48 19.25 19.9074 19.0322C20.2837 18.8405 20.5905 18.5342 20.7822 18.1579C21 17.7305 21 17.1715 21 16.0536V11.25M3 11.25V9.25M3 11.25H21M3 9.25V8.4502C3 7.33009 3 6.76962 3.21799 6.3418C3.40973 5.96547 3.71547 5.65973 4.0918 5.46799C4.51962 5.25 5.08009 5.25 6.2002 5.25H17.8002C18.9203 5.25 19.4796 5.25 19.9074 5.46799C20.2837 5.65973 20.5905 5.96547 20.7822 6.3418C21 6.7692 21 7.32899 21 8.44691V9.25M3 9.25H21M7 15.25H11M21 11.25V9.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/Credit.dd3cb66c58b5a66f0a572371af65823a.svg";
export { ForwardRef as ReactComponent };